var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs196"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#008669",
      strokeWidth: 1.31444,
      strokeLinejoin: "bevel"
    },
    id: "rect358",
    width: 32,
    height: 32,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 6.40096,27.2 V 4.8 h 10.8 c 4.6392,0 8.4,3.760816 8.4,8.4 V 14 c 0,2.864752 -1.43408,5.39456 -3.62352,6.91072 L 25.60864,27.2 h -5.54256 l -2.7716,-4.80048 C 17.26334,22.39984 17.23218,22.4 17.20096,22.4 h -6 v 4.8 z m 10.8,-17.6 c 1.988224,0 3.6,1.611776 3.6,3.6 V 14 c 0,1.988224 -1.611776,3.6 -3.6,3.6 h -6 v -8 z",
    fill: "black",
    id: "path190",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.6
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevitIcon);
export default __webpack_public_path__ + "static/media/RevitIcon.3f628795224dbc49baa32b6e9dab22d2.svg";
export { ForwardRef as ReactComponent };